import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ChevronUp } from "react-bootstrap-icons";

const ScrollToTop = () => {
  const [show, setShow] = useState(false);

  const showHandler = (e) => {
    setShow(document.documentElement.scrollTop > 500);
  };

  useEffect(() => {
    window.addEventListener("scroll", showHandler);

    return () => {
      window.removeEventListener("scroll", showHandler);
    };
  }, []);

  return (
    <React.Fragment>
      {show && (
        <Button
          variant="secondary"
          className="position-fixed rounded-circle"
          style={{
            bottom: "20px",
            left: "20px",
            width: "50px",
            height: "50px",
          }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <ChevronUp size={25} />
        </Button>
      )}
    </React.Fragment>
  );
};

export default ScrollToTop;
